var csFiltersInit;

(function ($) {

	const selectors = {
		filters: '[data-cs-filters]',
		allFilter: '[data-cs-filter="all"]',
		filter: '[data-cs-filter]',
		grid: '[data-cs-grid]',
	}

	csFiltersInit = function () {
		$(selectors.filters).each((i, el) => {
			new CsFilters(el);
		});
	}

	class CsFilters {
		constructor(el) {

			this.$filtersWrap = $(el);

			this.init();
			this.bind();
		}

		init() {

			this.$wrap = this.$filtersWrap.closest('section');

			this.$allFilter = $(selectors.allFilter, this.$wrap);
			this.$filter = $(selectors.filter, this.$wrap).not(this.$allFilter);
			this.$grid = $(selectors.grid, this.$wrap);

			this.filtersChanged = false;

		}

		bind() {

			const self = this;

			this.resetFilters = this.resetFilters.bind(this);
			this.applyFilters = this.applyFilters.bind(this);

			this.$allFilter.on('click', (e) => { e.preventDefault(); self.resetFilters() });
			this.$filter.on('change', () => { self.applyFilters(false) });
			$(window).on('hp-plugins-loaded', () => { self.applyFilters(true) });
			$(window).on('post-load', () => { self.$filtersWrap.removeClass('is-loading'); });
		}

		resetFilters() {
			this.$filter.each((i, el) => {
				if ($(el).find('[data-default]').length) {
					$(el).find('[data-default]').prop('selected', true);

				}
				else {
					$(el).find('[value=""]').prop('selected', true);
				}
			});

			this.applyFilters(false);
		}

		applyFilters(initial) {

			var filters = {};

			this.$filter.each((i, el) => {
				const tax = $(el).attr('name');
				const val = $(el).is('select') ? $(el).find(':selected').val() : $(el).val();

				if (val) {
					$(el).addClass('is-active');
					filters[tax] = val;
				}
				else {
					$(el).removeClass('is-active');
				}
			});

			this.$grid.attr('data-filters', JSON.stringify(filters));
			if ((initial && filters.length) || !initial) {
				this.$grid.attr('data-current-page', '0');
				this.$grid.trigger('reload');
				this.$filtersWrap.addClass('is-loading');
			}

		}
	}

})(jQuery);

export default csFiltersInit;